import { message } from 'antd';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import { API } from '../../config/api/index';
import { getItem } from '../../utility/localStorageControl';

const {
  getDigitalCards,
  getDigitalCardsBegin,
  getDigitalCardsError,
  generateDigitalCard,
  generateDigitalCardBegin,
  generateDigitalCardError,
} = actions;

const fetchDigitalCards = params => {
  return async dispatch => {
    try {
      const { page = 1, limit = 10, searchText = '' } = params || {};
      dispatch(getDigitalCardsBegin());
      const response = await DataService.get(
        `${API.pos.cards}/?sortBy=createdAt:desc&page=${page}&limit=${limit}&searchText=${searchText}&isDigital=true`,
      );
      return dispatch(getDigitalCards(response.data));
    } catch (err) {
      return dispatch(getDigitalCardsError(err?.message || 'Error al intentar obtener las tarjetas digitales.'));
    }
  };
};

const generateDigitalCardAction = data => {
  return async dispatch => {
    try {
      dispatch(generateDigitalCardBegin());
      const response = await DataService.post(API.images.generateDigitalCard, {
        name: data.name,
        cellphone: data.cellphone,
        email: data.email,
        description: data.description,
        montoRecarga: data.montoRecarga || 0,
      });
      message.success('Tarjeta digital generada con éxito');
      dispatch(generateDigitalCard(response.data?.card || response.data));
      dispatch(fetchDigitalCards());
    } catch (err) {
      dispatch(generateDigitalCardError(err?.message || 'Error al generar la tarjeta digital'));
    }
  };
};

const downloadCardImage = cardName => {
  const user = getItem('user');
  const token = user?.tokens?.access?.token;
  const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
  const url = `${apiEndpoint}${API.images.cardImage}/${cardName}`;

  fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(res => res.blob())
    .then(blob => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `tarjeta-${cardName}.png`;
      link.click();
      URL.revokeObjectURL(link.href);
    })
    .catch(() => {
      message.error('Error al descargar la imagen');
    });
};

const downloadCardPDF = cardName => {
  const user = getItem('user');
  const token = user?.tokens?.access?.token;
  const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
  const url = `${apiEndpoint}${API.images.cardPdf}/${cardName}`;

  fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(res => res.blob())
    .then(blob => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `tarjeta-${cardName}.pdf`;
      link.click();
      URL.revokeObjectURL(link.href);
    })
    .catch(() => {
      message.error('Error al descargar el PDF');
    });
};

export { fetchDigitalCards, generateDigitalCardAction, downloadCardImage, downloadCardPDF };
